import { loadScript, customerSafeError } from '../loadScript.js';

/**
 * PayPal's buttons render on our page and approval happens in a popup, so the
 * customer stays on the merchant's checkout.
 *
 * Capture happens on our server after approval — never here. A browser cannot be
 * trusted to tell us money moved.
 */
export async function mount({ session, container, onApproved, onError, onCancel }) {
  const paypal = await loadScript(session.scriptUrl, { globalName: 'paypal' });

  const buttons = paypal.Buttons({
    style: { layout: 'vertical', shape: 'rect', label: 'pay', height: 48 },
    // The order already exists — our server minted it, with the amount it decided.
    createOrder: () => session.orderId,
    onApprove: async (data) => {
      onApproved?.({ paypal_order_id: data.orderID ?? session.orderId });
    },
    onCancel: () => onCancel?.(),
    onError: (err) => {
      onError?.(customerSafeError('paypal_error', err?.message));
    },
  });

  await buttons.render(container);

  return () => {
    try {
      buttons.close();
    } catch {
      /* already closed */
    }
  };
}

export default { mount, rendersOwnButton: true };
